Ext.define('PanelFiltrTypyMiedzymagazynowe', {
    extend: 'Ext.panel.Panel',
    initComponent: function () {
        this.cid = Ext.id();
        Ext.apply(this, {
            layout: "fit",
            frame: false,
            border: false,
            autoWidth: false,
            autoHeight: false,
            items: [{
                xtype: 'form',
                frame: false,
                border: false,
                autoWidth: true,
                autoHeight: true,
                bodyStyle: 'padding:10px 10px 10px 10px',
                defaults: {
                    anchor: "0"
                },
                id: this.cid + "formpanel",
                labelWidth: 100,
                items: [{
                    anchor: "0",
                    layout: 'column',
                    frame: false,
                    border: false,
                    items: [{
                        columnWidth: 1.0,
                        layout: 'form',
                        labelWidth: 100,
                        defaults: {
                            anchor: "0"
                        },
                        frame: false,
                        border: false,
                        items: [{
                            id: this.cid + "nie",
                            value: false,
                            xtype: 'checkboxexd',
                            hideLabel: true,
                            boxLabel: Lang.nie.capitalise()
                        }, {
                            id: this.cid + "tak",
                            value: true,
                            xtype: 'checkboxexd',
                            hideLabel: true,
                            boxLabel: Lang.tak.capitalise()
                        }]
                    }]
                }]
            }]
        });
        this.callParent(arguments);
    },
    callAfterShow: function () {
        var t0 = Ext.getCmp(this.cid + "nie");
        var t1 = Ext.getCmp(this.cid + "tak");
        var bbem = this.datad.mainCtrl.repDef.typyMiedzymagazynowe.length == 0;
        t0.setValue(Ext.Array.contains(this.datad.mainCtrl.repDef.typyMiedzymagazynowe, 0) || bbem);
        t1.setValue(Ext.Array.contains(this.datad.mainCtrl.repDef.typyMiedzymagazynowe, 1) || bbem);

        this.callAfterShowCalled = true;
    },
    callAfterHide: function () {
        if (this.callAfterShowCalled) {
            var t0 = Ext.getCmp(this.cid + "nie");
            var t1 = Ext.getCmp(this.cid + "tak");
            this.datad.mainCtrl.repDef.typyMiedzymagazynowe = [];
            if (t0.getValue())
                this.datad.mainCtrl.repDef.typyMiedzymagazynowe.push(0);
            if (t1.getValue())
                this.datad.mainCtrl.repDef.typyMiedzymagazynowe.push(1);
        }
        return null;
    },
    setData: function (datad) {
        this.datad = datad;
    }
});
